<template>
  <div id="app">
    
    <TestuserBuilder/>
  </div>
</template>

<script>
import TestuserBuilder from './components/TestuserBuilder.vue'




export default {
  name: 'app',
  components: {
    TestuserBuilder
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
